import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatSerial = (serial, isNonSerialized) => {
  if (isNonSerialized || (serial && serial.startsWith('NSN-'))) return 'NSN';
  return serial ? serial.toUpperCase() : 'N/A';
};

// Postgres `date` columns arrive as 'YYYY-MM-DD'. new Date() reads that as
// midnight UTC, which renders as the previous day in US timezones, so build
// date-only strings as local midnight instead. Timestamps parse normally.
export const parseDate = (value) => {
  if (!value) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return new Date(value);
};

// A date (default: now) as 'YYYY-MM-DD' in the user's timezone. (toISOString() gives the
// UTC date, which is already tomorrow on US evenings.)
export const todayLocal = (d = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return parseDate(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};